const columns = [
  {
    id: "name",
    label: "NOMBRE Y APELLIDO",
    align: "left",
    disablePadding: false,
    sort: true,
  },
  {
    id: "documentNumber",
    label: "DOCUMENTO",
    align: "left",
    disablePadding: false,
    sort: true,
  },
  {
    id: "gender",
    label: "GENERO",
    align: "left",
    disablePadding: false,
    sort: true,
  },
  {
    id: "birthDate",
    label: "FECHA DE NACIMIENTO",
    align: "left",
    disablePadding: false,
    sort: false,
  },
];

export default columns;
